export { default } from './components/PostInput'
